import { put, takeLatest } from "redux-saga/effects";
import { postConfirmTimelineCRMApi } from "store/api/signtureApi";
import { CONFIRM_TIMELINE_CRM_ACTION } from "../../actions/SignatureAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postConfirmTimelineCRM(action) {
	yield put(globalAction.openLoadingPage());
	const { isConfirm, onSuccess } = action.params;
	const data = {
		isConfirm: isConfirm
	};
	const res = yield postConfirmTimelineCRMApi(data);
	try {
		if (res?.code === 0) {
			onSuccess();
			yield showMessage(false, res?.message);
		} else {
			yield showMessage(true, res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postConfirmTimelineCRMSaga() {
	yield takeLatest(CONFIRM_TIMELINE_CRM_ACTION, postConfirmTimelineCRM);
}

export default postConfirmTimelineCRMSaga;
